/**
 * NewCoinRealtimeProvider
 *
 * Thin provider that mounts the `useNewCoinRealtime` subscription at the
 * app root so that every client receives `launched_tokens` INSERT events
 * and refreshes the home grid, trending carousel, and feed caches within
 * ~1 second of a new coin launch.
 *
 * Must be rendered INSIDE VisibilityReconnectProvider so the hook can
 * consume `wakeCounter` for post-wake re-subscription.
 */

import { useNewCoinRealtime } from '@/hooks/useNewCoinRealtime';

export function NewCoinRealtimeProvider({ children }: { children: React.ReactNode }) {
  useNewCoinRealtime();
  return <>{children}</>;
}
